module.exports = __webpack_public_path__ + "img/store.d1203687.svg";